

































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import CardInputSKJiwa from "@/components/pemeriksaan/resumeSuketV2/CardInputSKJiwa.vue";
import moment from "moment";
import BaseCardSuket from "./BaseCardSuket.vue";
import { SuketSehatJiwaInterface } from "@/types/suket_sehat_jiwa";
import StoreSuketSehatJiwa from "@/store/modules/SuketSehatJiwa";
import SuketSehatJiwa from "@/services/SuketSehatJiwa";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";

@Component({
  components: {
    CardModalTtd,
    CardInputSKJiwa,
    BaseCardSuket
  },
  inject: {
    pageIsReadOnly: { from: "isReadOnly", default: () => () => false }
  }
})
export default class CardSKJiwa extends Vue {
  @Prop() readonly register!: string;
  pageIsReadOnly!: () => boolean;

  expandInput = false;
  pageTab = "tab-soap";
  allowedUnit = ["13", "2E", "2Q"];
  modalTtd = false;

  get dataSuket(): SuketSehatJiwaInterface {
    return StoreSuketSehatJiwa.suket;
  }

  get tglSurat() {
    return moment(this.dataSuket?.created_at).format("DD-MM-YYYY");
  }

  get loadContent() {
    return StoreSuketSehatJiwa.loading;
  }

  get creatorUserId() {
    return this.dataSuket?.dokter_id;
  }

  get signeeUserId() {
    return this.dataSuket?.dokter_id;
  }

  get isReadOnly() {
    if (this.pageIsReadOnly()) return true;
    return !this.allowedUnit.includes(userModule.user.unit_id);
  }

  backPageSoap() {
    this.$emit("pageTab", this.pageTab);
  }

  print(id) {
    SuketSehatJiwa.print(id);
  }

  showInput() {
    this.expandInput = true;
  }

  closeInput() {
    this.expandInput = false;
  }

  showSignatureModal() {
    this.modalTtd = true;
  }

  passTtd(value) {
    appModule.setLoading(true);

    // console.log(value);
    SuketSehatJiwa.sign(this.dataSuket.id, { password: value })
      .then(dt => {
        if (dt.status == 1) {
          appModule.NoticeDelay("Berhasil Tanda Tangan SKDP");
          appModule.addMsgTtd("");
          StoreSuketSehatJiwa.getSuketByRegister(this.register);
        } else {
          appModule.sendErrorAlert(dt.message);
        }
      })
      .finally(() => {
        appModule.setLoading(false);
        this.modalTtd = false;
      });
  }

  hapusSuket() {
    SuketSehatJiwa.destroy(this.dataSuket.id)
      .then(dt => {
        if (dt.status == 1) {
          appModule.NoticeDelay("Berhasil Hapus Surat Sehat Rohani");
          StoreSuketSehatJiwa.getSuketByRegister(this.register);
        } else {
          appModule.sendErrorAlert(dt.message);
        }
      })
      .finally(() => {
        appModule.setLoading(false);
      });
  }
}
